import { UserRole } from '@/features/auth/types'

export const ROLE_LABELS: Record<UserRole, string> = {
  [UserRole.SUPER_ADMIN]: 'Super administrador',
  [UserRole.ORG_ADMIN]: 'Administrador de organización',
  [UserRole.COMPANY_ADMIN]: 'Administrador de empresa',
  [UserRole.ANALYST]: 'Analista',
  [UserRole.VIEWER]: 'Solo lectura',
}
